<template>
  <a-form-item :label="label">
    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      v-model:value="selected"
      mode="multiple"
      show-arrow
      @change="handleChange"
    >
      <a-select-option v-for="item in items || dataEmpty" :key="item.id">
        {{ item.name }}
      </a-select-option>
    </a-select>
  </a-form-item>
</template>
<script>
export default {
  props: {
    value: {
      required: false,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    },
    label: {
      required: false,
      type: String,
      default: "",
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(tags) {
        const selectedItems = this.items.filter((currentItem) => {
          return tags.includes(currentItem.id);
        });
        console.log(selectedItems);
        this.$emit("update:value", selectedItems);
      },
    },
  },
  methods: {
    handleChange(value) {
      this.$emit("change", value);
    },
  },
};
</script>

<style lang="sass" scoped>
.text
  padding: 12px 24px
  margin: 0

  &--bold
    color: $gray-9
    font-weight: 600

.ant-form-item
  margin-bottom: 4px
</style>
